import { render, staticRenderFns } from "./BillingHeaderBASF02FGIndex.vue?vue&type=template&id=236bc6a8&scoped=true&"
import script from "./BillingHeaderBASF02FGIndex.vue?vue&type=script&lang=js&"
export * from "./BillingHeaderBASF02FGIndex.vue?vue&type=script&lang=js&"
import style0 from "./BillingHeaderBASF02FGIndex.vue?vue&type=style&index=0&id=236bc6a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236bc6a8",
  null
  
)

export default component.exports